import gql from 'graphql-tag';
import { OrderUpdateLogOriginal } from '../fragments';

export default gql`
query orderUpdateLogs($order_id: ID!) {
    orderUpdateLogs(order_id: $order_id) {
        modified_by_erp
        erp_admin_name
        original {
            ...OrderUpdateLogOriginal
        }
        new {
            ...OrderUpdateLogOriginal
        }
        created_at
    }
}
${OrderUpdateLogOriginal}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/orderUpdateLogs.ts